import { Layout } from 'antd';
import styled from 'styled-components';
const { Header, Sider, Content } = Layout;

export const SideBarStyle = styled(Sider)`
  height: 100vh;
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
`;
export const ContentStyled = styled(Content)`
  margin: 0;
  width: 100%;
  overflow-y: auto;
  height: ${({ fullscreen }) => (fullscreen ? 'calc(100vh - 6vh)' : 'calc(100vh - 6vh - 87px)')};
  top: ${({ fullscreen, withoutMenu }) => (fullscreen ? '0px' : withoutMenu ? '97px' : '110px')};
  position: ${({ fixed }) => (fixed ? 'fixed' : 'relative')};
  border-radius: ${({ fullscreen }) => (fullscreen ? '0px' : '0px 40px 0px 0px')};
`;

export const HeaderBarStyle = styled(Header)`
  padding: 0 !important;
  position: fixed !important;
  top: 0;
  width: 100vw;
  height: 200px;
  text-align: center;
  background-color: #ec1d24; //red
`;

export const TopBarTool = styled.div`
  width: 100%;
  text-align-last: right;
  justify-content: flex-end;
  align-items: center;
  display: inline;
`;

export const TopBarDropDown = styled.div`
  padding-top: 5px;
  padding-right: 3%;
`;

export const TopBarUser = styled.div`
  text-align-last: right;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  padding-right: 2px;
`;

export const VersionTag = styled.div`
  text-align: center;
  display: ${({ collapse }) => (collapse ? 'none' : 'list-item')};
`;
